import { createFileRoute } from '@tanstack/react-router'
import { MouvementView } from '@features/stock/components/MouvementView'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/mouvements/$id/view')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.MOVEMENTS.VIEW, context)
  },
  component: ViewMouvementComponent,
})

function ViewMouvementComponent() {
  const { id } = Route.useParams()
  const { canView } = usePermissions()
    
  if (!canView('stock.movements.view')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return <MouvementView id={Number(id)} />
}
